export enum PostTypeEnum {
  UserStatus = 0,
  VideoTutorial = 1,
  InviteFriend = 2,
  AudioTrack = 3,
}
